/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M16 6C16 3.79086 14.2091 2 12 2C9.79086 2 8 3.79086 8 6M8 11V14M16 11V14M2.5 11C2.5 11 7 13 12 13C17 13 21.5 11 21.5 11"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="6"
				width="20"
				height="16"
				rx="4"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M8.4 22H15.6C17.8402 22 18.9603 22 19.816 21.564C20.5686 21.1805 21.1805 20.5686 21.564 19.816C22 18.9603 22 17.8402 22 15.6V10.5C20 12 15 13 12 13C9 13 4 12 2 10.5V15.6C2 17.8402 2 18.9603 2.43597 19.816C2.81947 20.5686 3.43139 21.1805 4.18404 21.564C5.03969 22 6.15979 22 8.4 22Z"
				fill="currentColor"
			/>
			<path
				d="M2.5 11C2.5 11 4.83015 12.0356 8 12.6164M8 12.6164C9.23522 12.8427 10.598 13 12 13C13.402 13 14.7648 12.8427 16 12.6164M8 12.6164V11M8 12.6164V14M16 12.6164C19.1699 12.0356 21.5 11 21.5 11M16 12.6164V11M16 12.6164V14M16 6C16 3.79086 14.2091 2 12 2C9.79086 2 8 3.79086 8 6M8.4 22H15.6C17.8402 22 18.9603 22 19.816 21.564C20.5686 21.1805 21.1805 20.5686 21.564 19.816C22 18.9603 22 17.8402 22 15.6V12.4C22 10.1598 22 9.03968 21.564 8.18404C21.1805 7.43139 20.5686 6.81947 19.816 6.43597C18.9603 6 17.8402 6 15.6 6H8.4C6.15979 6 5.03968 6 4.18404 6.43597C3.43139 6.81947 2.81947 7.43139 2.43597 8.18404C2 9.03968 2 10.1598 2 12.4V15.6C2 17.8402 2 18.9603 2.43597 19.816C2.81947 20.5686 3.43139 21.1805 4.18404 21.564C5.03968 22 6.15979 22 8.4 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.83697 5.25C9.17555 3.81665 10.4632 2.75 12 2.75C13.5368 2.75 14.8245 3.81665 15.163 5.25H8.83697ZM7.30887 5.25006C7.66843 2.98304 9.63183 1.25 12 1.25C14.3682 1.25 16.3316 2.98304 16.6911 5.25006C18.7062 5.25118 19.7549 5.27271 20.566 5.68597C21.3186 6.06947 21.9305 6.68139 22.314 7.43404C22.6291 8.05247 22.7165 8.80905 22.7407 10.0268C20.8097 10.9068 18.7975 11.5377 16.75 11.9195V11C16.75 10.5858 16.4142 10.25 16 10.25C15.5858 10.25 15.25 10.5858 15.25 11V12.1539C13.0921 12.4267 10.9079 12.4267 8.75 12.1539V11C8.75 10.5858 8.41421 10.25 8 10.25C7.58579 10.25 7.25 10.5858 7.25 11V11.9195C5.2025 11.5377 3.19026 10.9068 1.25929 10.0268C1.28351 8.80905 1.37087 8.05247 1.68597 7.43404C2.06947 6.68139 2.68139 6.06947 3.43404 5.68597C4.24511 5.27271 5.2938 5.25118 7.30887 5.25006ZM1.25 16.35V11.662C3.19149 12.4901 5.20508 13.0841 7.25 13.4439V14.5C7.25 14.9142 7.58579 15.25 8 15.25C8.41421 15.25 8.75 14.9142 8.75 14.5V13.6652C10.9088 13.9229 13.0912 13.9229 15.25 13.6652V14.5C15.25 14.9142 15.5858 15.25 16 15.25C16.4142 15.25 16.75 14.9142 16.75 14.5V13.4439C18.7949 13.0841 20.8085 12.4901 22.75 11.662V16.35C22.75 18.5902 22.75 19.7103 22.314 20.566C21.9305 21.3186 21.3186 21.9305 20.566 22.314C19.7103 22.75 18.5902 22.75 16.35 22.75H7.65C5.40979 22.75 4.28969 22.75 3.43404 22.314C2.68139 21.9305 2.06947 21.3186 1.68597 20.566C1.25 19.7103 1.25 18.5902 1.25 16.35Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M2.5 11C2.5 11 4.83015 12.0356 8 12.6164M8 12.6164C9.23522 12.8427 10.598 13 12 13C13.402 13 14.7648 12.8427 16 12.6164M8 12.6164V11M8 12.6164V14M16 12.6164C17.129 12.4096 18.1514 12.145 19 11.8901M16 12.6164V11M16 12.6164V14M16 6C16 3.79086 14.2091 2 12 2C9.79086 2 8 3.79086 8 6M8.4 22H15.6C17.8402 22 18.9603 22 19.816 21.564C20.5686 21.1805 21.1805 20.5686 21.564 19.816C22 18.9603 22 17.8402 22 15.6V12.4C22 10.1598 22 9.03968 21.564 8.18404C21.1805 7.43139 20.5686 6.81947 19.816 6.43597C18.9603 6 17.8402 6 15.6 6H8.4C6.15979 6 5.03968 6 4.18404 6.43597C3.43139 6.81947 2.81947 7.43139 2.43597 8.18404C2 9.03968 2 10.1598 2 12.4V15.6C2 17.8402 2 18.9603 2.43597 19.816C2.81947 20.5686 3.43139 21.1805 4.18404 21.564C5.03968 22 6.15979 22 8.4 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M2.5 11C2.5 11 4.83015 12.0356 8 12.6164M8 12.6164C9.23522 12.8427 10.598 13 12 13C13.402 13 14.7648 12.8427 16 12.6164M8 12.6164V11M8 12.6164V14M16 12.6164C19.1699 12.0356 21.5 11 21.5 11M16 12.6164V11M16 12.6164V14M16 6C16 3.79086 14.2091 2 12 2C9.79086 2 8 3.79086 8 6M8.4 22H15.6C17.8402 22 18.9603 22 19.816 21.564C20.5686 21.1805 21.1805 20.5686 21.564 19.816C22 18.9603 22 17.8402 22 15.6V12.4C22 10.1598 22 9.03968 21.564 8.18404C21.1805 7.43139 20.5686 6.81947 19.816 6.43597C18.9603 6 17.8402 6 15.6 6H8.4C6.15979 6 5.03968 6 4.18404 6.43597C3.43139 6.81947 2.81947 7.43139 2.43597 8.18404C2 9.03968 2 10.1598 2 12.4V15.6C2 17.8402 2 18.9603 2.43597 19.816C2.81947 20.5686 3.43139 21.1805 4.18404 21.564C5.03968 22 6.15979 22 8.4 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M7.65 22.75H16.35C18.5902 22.75 19.7103 22.75 20.566 22.3141C21.3186 21.9306 21.9305 21.3187 22.314 20.566C22.75 19.7104 22.75 18.5903 22.75 16.3501V10.8446C15.9023 13.8632 8.09773 13.8632 1.25 10.8446V16.35C1.25 18.5903 1.25 19.7104 1.68597 20.566C2.06947 21.3187 2.68139 21.9306 3.43404 22.3141C4.28969 22.75 5.40979 22.75 7.65 22.75Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 2.75C10.4632 2.75 9.17555 3.81665 8.83697 5.25H15.163C14.8245 3.81665 13.5368 2.75 12 2.75ZM12 1.25C9.63185 1.25 7.66846 2.98301 7.30888 5.25H6.84456C5.36062 5.25 4.61865 5.25 4.018 5.44446C2.79696 5.83975 1.83975 6.79696 1.44446 8.018C1.25 8.61865 1.25 9.36062 1.25 10.8446C3.18783 11.6988 5.20229 12.3113 7.25 12.682V14.5C7.25 14.9142 7.58579 15.25 8 15.25C8.41421 15.25 8.75 14.9142 8.75 14.5V12.9097C10.9084 13.1748 13.0916 13.1748 15.25 12.9097V14.5C15.25 14.9142 15.5858 15.25 16 15.25C16.4142 15.25 16.75 14.9142 16.75 14.5V12.682C18.7977 12.3113 20.8122 11.6988 22.75 10.8446C22.75 9.36062 22.75 8.61865 22.5555 8.018C22.1602 6.79696 21.203 5.83975 19.982 5.44446C19.3813 5.25 18.6394 5.25 17.1554 5.25H16.6911C16.3315 2.98301 14.3682 1.25 12 1.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
